'use strict';

let env = require('shared/scripts/env');

function routing($stateProvider) {

    $stateProvider

    /**
     * Base route for routes that requires an api-endpoint
     */
        .state('root.api-endpoints', {
            url: "/app?"
            + "cf_ClerkVatScenario_page?"
            + "&cf_ClerkVatScenario_order?"
            + "&cf_ClerkVatScenario_search?"
            + "&cf_ClerkLedgerAccount_page?"
            + "&cf_ClerkLedgerAccount_order?"
            + "&cf_ClerkLedgerAccount_search?"
            + "&cf_ClerkLedgerEntryType_page?"
            + "&cf_ClerkLedgerEntryType_order?"
            + "&cf_ClerkLedgerEntryType_search?"
            + "&cf_Input_search?"
            + "&cf_ClerkAccount_search?"
            + "&cf_ClerkInvoice_search?"
            + "&cf_ClerkInvoiceRow_search?"
            + "&cf_ClerkTaxEntity_search?"
            + "&cf_ClerkTaxEntityType_search?"
            + "&cf_ClerkFiscalYear_search?"
            + "&cf_ClerkSupportingDocument_search?"
            + "&cf_ClerkTransactionRow_search?"
            + "&cf_ClerkTravelClaim_search?"
            + "&cf_ClerkTravelTrip_search?"
            ,
            params: {
                cf_ClerkVatScenario_page: {value: '1', dynamic: true},
                cf_ClerkVatScenario_order: {value: null, dynamic: true},
                cf_ClerkVatScenario_search: {value: null, dynamic: true},
                cf_ClerkLedgerAccount_page: {value: '1', dynamic: true},
                cf_ClerkLedgerAccount_order: {value: null, dynamic: true},
                cf_ClerkLedgerAccount_search: {value: null, dynamic: true},
                cf_ClerkLedgerEntryType_page: {value: '1', dynamic: true},
                cf_ClerkLedgerEntryType_order: {value: null, dynamic: true},
                cf_ClerkLedgerEntryType_search: {value: null, dynamic: true},
                cf_Input_search: {value: null, dynamic: true},
                cf_ClerkAccount_search: {value: null, dynamic: true},
                cf_ClerkInvoice_search: {value: '', dynamic: true},
                cf_ClerkInvoiceRow_search: {value: '', dynamic: true},
                cf_ClerkTaxEntity_search: {value: null, dynamic: true},
                cf_ClerkTaxEntityType_search: {value: null, dynamic: true},
                cf_ClerkFiscalYear_search: {value: null, dynamic: true},
                cf_ClerkSupportingDocument_search: {value: null, dynamic: true},
                cf_ClerkTransactionRow_search: {value: null, dynamic: true},
                cf_ClerkTravelClaim_search: {value: null, dynamic: true},
                cf_ClerkTravelTrip_search: {value: null, dynamic: true},
            },
            template: require("project/views/start.html"),
            resolve: {
                setRouteBasedContentFiltersLevel0: /*@ngInject*/ function (routeBasedContentFilters, $stateParams) {
                    routeBasedContentFilters.ImportSession_order = 'ImportSession.created DESC';
                    routeBasedContentFilters.InputResult_order = 'InputResult.created DESC';
                    routeBasedContentFilters.Activity_order = 'Activity.created DESC';
                    routeBasedContentFilters.ClerkInvoice_order = 'ClerkInvoice.invoice_date IS NULL DESC, ClerkInvoice.invoice_date DESC, ClerkInvoice.invoice_number IS NULL DESC, ClerkInvoice.invoice_number DESC, ClerkInvoice.due_date IS NULL DESC, ClerkInvoice.due_date DESC, ClerkInvoice.created DESC, ClerkInvoice.id DESC';
                    routeBasedContentFilters.ClerkInvoiceRow_order = 'ClerkInvoice.invoice_date IS NULL DESC, ClerkInvoice.invoice_date DESC, ClerkInvoice.invoice_number IS NULL DESC, ClerkInvoice.invoice_number DESC, ClerkInvoice.due_date IS NULL DESC, ClerkInvoice.due_date DESC, ClerkInvoice.created DESC, ClerkInvoice.id DESC, ClerkInvoiceRow.id DESC';
                    routeBasedContentFilters.ClerkFiscalYear_order = 'ClerkFiscalYear.clerk_tax_entity_id ASC, ClerkFiscalYear.end_utc_datetime DESC';
                    routeBasedContentFilters.ClerkLedger_order = 'clerk_fiscal_year.clerk_tax_entity_id ASC, clerk_fiscal_year.start_utc_datetime DESC';
                    routeBasedContentFilters.ClerkLedgerEntry_limit = 100;
                    routeBasedContentFilters.ClerkAccountBalance_order = 'ClerkAccountBalance.date DESC, ClerkAccountBalance.id ASC';
                    routeBasedContentFilters.ClerkSupportingDocument_order = 'ClerkSupportingDocument.relevant_date_settled IS NULL DESC, ClerkSupportingDocument.relevant_date_settled DESC, ClerkSupportingDocument.created DESC, ClerkSupportingDocument.id DESC';
                },
            },
            data: {
                requiresLogin: true
            }
        })

        /**
         * Route that allows the user to select current domain
         */
        .state('root.api-endpoints.choose', {
            url: "/choose-account",
            template: require("project/views/domain/choose-current.html"),
            data: {pageTitle: 'Choose linked account'}
        })

        /**
         * Route that sets the current domain to one in the url and then shows the "start" view
         */
        .state('root.api-endpoints.existing', {
            abstract: true,
            url: "/:dataEnvironment",
            template: "<ui-view/>",
            resolve: {

                loadDataEnvironmentSpecific: ($q, $ocLazyLoad, $injector, $rootScope) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('project/scripts/data-environment-specific/data-environment-specific.js');
                            $ocLazyLoad.load({name: module.name}).then(function () {

                                // keep a reference to the suggested actions collection singleton in rootScope for access in all views
                                $injector.invoke(['suggestedActions', function (suggestedActions) {
                                    $rootScope.suggestedActions = suggestedActions;
                                }]);

                                resolve(module);
                            });
                        })
                    });
                },

                // all child states of root.api-endpoints.existing needs information about the current api endpoint to query rest api requests against
                // such information is stored in the route, why we need to read $stateParams and set the current api endpoint based on the route
                dataEnvironmentParam: function ($stateParams, DataEnvironmentService, auth, $injector) {
                    //console.log('root.api-endpoints.existing dataEnvironmentParam - dataEnvironmentParam, $stateParams, DataEnvironmentService', $stateParams, DataEnvironmentService);

                    // Set active endpoint based on state param
                    DataEnvironmentService.setDataEnvironment($stateParams.dataEnvironment);

                    return DataEnvironmentService.activeDataEnvironment.promise;

                },
            },
            data: {
                pageTitle: 'Start',
                notTheStartView: true, // Workaround for the fact that start.html needs to be specified on the parent view
            }
        })

        .state('root.api-endpoints.existing.start', {
            url: "/start",
            template: '<ui-view/>',
            data: {
                pageTitle: 'Start',
                notTheStartView: false, // Workaround for the fact that start.html needs to be specified on the parent view
            }
        })

    /**
     * Wizard steps
     */
    /*
     .state('forms.wizard', {
     url: "/wizard",
     template: require("project/views/form_wizard.html"),
     controller: wizardCtrl,
     data: {pageTitle: 'Wizard form'},
     resolve: {
     loadPlugin: function ($ocLazyLoad) {
     return $ocLazyLoad.load([
     {
     files: ['css/plugins/steps/jquery.steps.css']
     }
     ]);
     }
     }
     })
     .state('forms.wizard.step_one', {
     url: '/step_one',
     templateUrl: 'views/wizard/step_one.html',
     data: {pageTitle: 'Wizard form'}
     })
     .state('forms.wizard.step_two', {
     url: '/step_two',
     templateUrl: 'views/wizard/step_two.html',
     data: {pageTitle: 'Wizard form'}
     })
     .state('forms.wizard.step_three', {
     url: '/step_three',
     templateUrl: 'views/wizard/step_three.html',
     data: {pageTitle: 'Wizard form'}
     })
     */
    ;

}

export default angular
    .module('data-environment-specific.routing', [])
    .config(routing);



// WEBPACK FOOTER //
// .-dna/app/scripts/data-environment-specific/data-environment-specific.routing.js